import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TitlePage from 'components/TituloPage';
import * as S from '../styles';
import FormDetalheDadosCadastrais from 'containers/DetalheDadosCadastrais';
import * as Style from 'components/Style';
import { cadastroContribuinte, editarContribuinte, homeContribuinte } from 'routes/paths';
import { ENUM_TIPO_PESSOA } from 'utils/consts';
import { Row } from 'antd';
import InputDropdown from 'components/InputDropdown';
import Titulo from 'components/Titulo';
import { duckDadosCadastraisDetalhar } from 'store/ducks/dadosCadastrais';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import Button from 'components/Button';
import { fetchGetDadosCadastrais } from 'store/fetchActions/fetchDadosCadastrais';
import { formatterDadosCadastraisBackToFront } from 'utils/formatter/dadosCadastrais';

export default function PageDadosCadastraisVisualizar() {
  const dispatch = useDispatch();
  const history = useHistory();

  const dadosCadastraisDetalhar = useSelector(state => state.dadosCadastrais.dadosCadastraisDetalhar);

  React.useEffect(() => {
    if (!dadosCadastraisDetalhar) {
      dispatch(fetchGetDadosCadastrais()).then(pessoas => {
        if (pessoas?.length > 0) {
          dispatch(duckDadosCadastraisDetalhar(formatterDadosCadastraisBackToFront(pessoas)));
        } else {
          history.push(cadastroContribuinte);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const { control, setValue } = useForm({ defaultValues: dadosCadastraisDetalhar });

  const onChange = e => {
    const { name, value } = e.target;
    setValue(name, value);
    if (name === 'tipoPessoa') dispatch(duckDadosCadastraisDetalhar({ ...dadosCadastraisDetalhar, tipoPessoa: value }));
  };

  return (
    <S.Contain className="boxShadow">
      <TitlePage textTitle={'DADOS CADASTRAIS - VISUALIZAR'} backPage={homeContribuinte} />
      <form>
        <Style.GlobalCard>
          <Row>
            <Titulo textTitle={'Dados Pessoais'} />
            <InputDropdown
              name="tipoPessoa"
              control={control}
              onChange={onChange}
              options={[ENUM_TIPO_PESSOA.fisica, ENUM_TIPO_PESSOA.juridica]}
              value={dadosCadastraisDetalhar?.tipoPessoa}
              disabled={true}
            />
            <S.ContainButtonEdit>
              <Button text={'Editar'} clickAction={() => history.push(editarContribuinte)} />
            </S.ContainButtonEdit>
          </Row>
          <FormDetalheDadosCadastrais
            dados={dadosCadastraisDetalhar}
            endereco={
              dadosCadastraisDetalhar?.tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao
                ? dadosCadastraisDetalhar?.enderecoPj
                : dadosCadastraisDetalhar?.enderecoPf
            }
          />
        </Style.GlobalCard>
      </form>
    </S.Contain>
  );
}
